<div
  class="grid-row items-center px-0"
  [ngClass]="{
    'py-3 grid-cols-[24px_1fr_10rem] gap-2': showLink,
    'grid-cols-[20px_1fr] gap-0.5 border-0': !showLink,
  }"
>
  <div
    class="flex items-center justify-center font-medium p-0"
    [ngClass]="{
      'size-5': showLink,
      'size-4': !showLink,
      'text-bright-crimson': isOverdue,
      'text-bright-orange': isDueSoon,
      'text-grey-blue/75': !isOverdue && !isDueSoon,
    }"
  >
    <ion-icon class="size-full" name="flag-outline"></ion-icon>
  </div>
  <div class="flex flex-col">
    <div class="line-clamp-2">{{ nextStep.attributes.description }}</div>
    <div
      class="flex items-center"
      [ngClass]="{
        'text-grey-blue/75': !isOverdue && !isDueSoon,
        'text-bright-crimson': isOverdue,
        'text-bright-orange': isDueSoon,
      }"
    >
      <span class="max-lg:text-xs text-xxs pt-0.5">Due {{ nextStep.attributes.due_date | date: 'dd MMM yyyy' }}</span>
    </div>
  </div>
  @if (showLink) {
    <div class="text-left pl-2">
      @if (nextStep.attributes.opportunity_id) {
        <div>
          <label class="text-xxs text-grey-blue/75">Opportunity</label>
          <a
            (click)="navigateToOpportunity($event)"
            class="font-medium text-xs btn-link"
            tooltip="View Opportunity Details"
          >
            OPP-{{ nextStep.attributes.opportunity_id }}
          </a>
        </div>
      } @else if (nextStep.attributes.lead_id) {
        <div>
          <label class="text-xxs text-grey-blue/75">Lead</label>
          <a (click)="navigateToLead($event)" class="font-medium text-xs btn-link" tooltip="View Lead Details">
            LEAD-{{ nextStep.attributes.lead_id }}
          </a>
        </div>
      } @else {
        <app-group-display
          [groupId]="nextStep.attributes.group_id"
          [groupName]="nextStep.attributes.group_name"
          (click)="closeModal()"
        ></app-group-display>
      }
    </div>
  }
</div>
